import styles from './list-item.module.css'
import cx from 'classnames'

export interface ListItemProps {
  classNames?: string
  label: string
  href?: string
  ariaLabel?: string
  handleClickEvent: () => void
  apiData?: number
}

export const ListItem = ({
  classNames,
  label,
  href,
  ariaLabel,
  handleClickEvent,
  apiData,
}: ListItemProps) => (
  <a
    href={href}
    aria-label={ariaLabel}
    className={cx(styles.listItem, classNames)}
    onClick={handleClickEvent}
  >
    {`${label} ${apiData ? `(${apiData})` : ''}`}
  </a>
)
